import { useMemo } from 'react';

interface WordDeclension {
  one: string;    // форма для 1 (например: "звезда")
  few: string;    // форма для 2-4 (например: "звезды")
  many: string;   // форма для 5+ (например: "звезд")
}

export const useWordDeclension = (count: number, words: WordDeclension): string => {
  return useMemo(() => {
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
      return words.many;
    }

    if (lastDigit === 1) {
      return words.one;
    }

    if (lastDigit >= 2 && lastDigit <= 4) {
      return words.few;
    }

    return words.many;
  }, [count, words]);
}; 